import { InjectionToken } from '@angular/core';

export interface DocsConfig {
  /** Editing/admin routes, e.g. `${environment.apiUrl}/company/wiki` - only admin needs this. */
  baseUrl: string;
  /** Read-only routes any role/app can hit, e.g. `${environment.apiUrl}/public/wiki`. */
  publicUrl: string;
}

export const DOCS_CONFIG = new InjectionToken<DocsConfig>('DOCS_CONFIG');
